export default __webpack_public_path__ + "static/transport-f7bec93f03cdcef3779922dfe7093236.mp4";